<template>
  <div class="social">
    <p class="social__title">Let your friends and colleagues know you’re becoming an expert!</p>
    <div class="social__actions-wrapper">
      <a
        v-for="action in actions"
        @click.prevent="handleEvent(action)"
        :key="action.name"
        :href="action.href"
        target="_blank"
        class="social__action"
        v-tooltip="{ content: `Share on ${action.name}`, placement: 'bottom' }"
      >
        <component :is="action.icon" class="social__action--icon" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FacebookIcon from '@/assets/icons/social/facebook_icon.svg'
import LinkedinIcon from '@/assets/icons/social/linkedin_icon.svg'
import TwitterIcon from '@/assets/icons/social/twitter_icon.svg'
import { eventsConstants } from '@/helpers/eventsList'

export default {
  name: 'SocialShareWidget',
  components: {
    FacebookIcon: { ...FacebookIcon, name: 'FacebookIcon' },
    LinkedinIcon: { ...LinkedinIcon, name: 'LinkedinIcon' },
    TwitterIcon: { ...TwitterIcon, name: 'TwitterIcon' },
  },
  computed: {
    ...mapState({
      paymentMethod: state => state.subscriptions.paymentMethod,
      utmParams: state => state.events.utmParams,
      promotionalField: state => state.subscriptions.promotionalField,
    }),
    ...mapGetters({
      selectedPlan: 'shoppingCart/selectedPlan',
      couponStr: 'coupons/getCoupon',
      totalStr: 'coupons/getTotalStr',
    }),
    actions() {
      return [
        {
          name: 'Facebook',
          icon: FacebookIcon,
          href: 'https://www.facebook.com/sharer.php?u=https://checkout.ine.com',
        },
        {
          name: 'LinkedIn',
          icon: LinkedinIcon,
          href: `https://www.linkedin.com/shareArticle?url=https://checkout.ine.com`,
        },
        {
          name: 'Twitter',
          icon: TwitterIcon,
          href: `https://twitter.com/intent/tweet?url=https://checkout.ine.com`,
        },
      ]
    },
  },
  methods: {
    handleEvent(action) {
      const {
        selectedPlan: { merchant_id },
      } = this
      this.sendMixpanelEvent(eventsConstants.CHECKOUT_USER_SOCIAL, {
        social_app: action.name,
        checkout_total: this.totalStr,
        payment_method: this.paymentMethod,
        plan_code: merchant_id || '',
        coupon: this.couponStr,
        special_offer: this.promotionalField,
        ...this.utmParams,
      })
      window.open(action.href, '_blank')
    },
  },
}
</script>

<style lang="scss">
.social {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  height: 157px;

  &__title {
    color: var(--white);
    font-family: var(--font-regular);
    font-weight: 450;
    font-size: rem(16);
    line-height: 24px;
    width: 100%;
    margin: auto 0 0 0;
    padding: 0;
    text-align: center;
  }
  &__actions-wrapper {
    display: flex;
    align-items: center;
  }
  &__action {
    background: transparent;
    border: none;
    border-radius: 100%;
    margin: 0 5px;
    cursor: pointer;
    padding: 5px;
    &:hover {
      background: #1e1e1e;
    }
    &--icon {
      fill: var(--white);
    }
  }
}
a.social__action.has-tooltip {
  display: flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
}
</style>
